import { Component, Inject, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { PROCTORED_RULES_NAME_DESCRIPTION } from '@edtech-ui/core/constants/recuritment-constants/proctoring-constants/ruleSets';
import { RULE_TYPE_MAP } from '@edtech-ui/constants/proctoring-services.enum';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-proctoring-add-update-rule-dialog',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './proctoring-add-update-rule-dialog.component.html',
	styleUrl: './proctoring-add-update-rule-dialog.component.scss'
})
export class ProctoringAddUpdateRuleDialogComponent {

	availableRules = PROCTORED_RULES_NAME_DESCRIPTION;
	remainingRules: any[] = [];
	selectedRules: any[] = [];
	dropdownOpen = false;


	constructor(
		public dialogRef: MatDialogRef<ProctoringAddUpdateRuleDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { existingRules: any[] },
		private toastr: ToastrService,
		private elementRef: ElementRef
	) {
		const existingRuleNames = this.data.existingRules.map(r => r.ruleName);
		this.remainingRules = this.availableRules.filter(r => !existingRuleNames.includes(r.name));
	}


	@HostListener('document:click', ['$event'])
	onClickOutside(event: Event) {
		if (this.dropdownOpen && !this.elementRef.nativeElement.querySelector('.rule-select-wrapper')?.contains(event.target as Node)) {
			this.dropdownOpen = false;
		}
	}


	toggleRule(rule: any) {
		const index = this.selectedRules.findIndex(x => x.name === rule.name);
		if (index > -1) {
			this.selectedRules.splice(index, 1);
		} else {
			this.selectedRules.push(rule);
		}
	}


	isSelected(rule: any) {
		return this.selectedRules.some(x => x.name === rule.name);
	}



	addRules() {
		if (this.selectedRules.length === 0) {
			this.toastr.error('Select at least one rule.');
			return;
		}
		const newRules = this.selectedRules.map(rule => ({
			ruleName: rule.name,
			ruleType: RULE_TYPE_MAP[rule.name] || 'AI_Proctoring',
			description: rule.description,
			severity: 'MEDIUM',
			thresholdCount: 3,
			thresholdWindowSeconds: 30,
			escalationAction: 'WARN',
			captureSnapshot: false,
			isEnabled: true,
			debounceSeconds: 5
		}));
		this.dialogRef.close(newRules);
	}


	close() {
		this.dialogRef.close();
	}
}
